import { render } from "./CurriculumMain.vue?vue&type=template&id=148b91f0&scoped=true&ts=true"
import script from "./CurriculumMain.vue?vue&type=script&lang=ts"
export * from "./CurriculumMain.vue?vue&type=script&lang=ts"

import "./CurriculumMain.vue?vue&type=style&index=0&id=148b91f0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148b91f0"]])

export default __exports__